import { Link } from "react-router";
import { useAtomValue } from "jotai";
import { localeAtom } from "../../stores/locale";
import { useT } from "../../lib/i18n";

// NotFound is the catch-all (path="*") surface. Before this, an unknown URL fell
// through <Routes> and rendered nothing — a blank white screen with no way back.
// It's deliberately self-contained (no galaxy Layout, no API calls): a bad URL
// may not resolve to any galaxy, so it must render without a valid :account in
// context. The "back" link points at "/" so GalaxyRedirect routes the user to
// their own galaxy — no account guessing here. Telescope framing per the EIS
// metaphor: an empty coordinate, not a generic error page.
export const NotFound = () => {
  const t = useT(useAtomValue(localeAtom));

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-lg px-lg text-center">
      <p className="font-mono text-6xl font-black tracking-tight text-gruvbox-bg4">
        {t("notfound.code")}
      </p>
      <h1 className="text-xl font-bold text-gruvbox-fg">{t("notfound.title")}</h1>
      <p className="max-w-[28rem] text-sm leading-relaxed text-gruvbox-gray">
        {t("notfound.body")}
      </p>
      <Link
        to="/"
        className="mt-md rounded-md border border-gruvbox-aqua/40 bg-gruvbox-aqua/10 px-lg py-md text-sm font-medium text-gruvbox-aqua transition-colors hover:bg-gruvbox-aqua/20"
      >
        {t("notfound.home")}
      </Link>
    </div>
  );
};
